import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/aktivnote/matrix',
	title:       'menu.aktivnote-matrix',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/aktivnote/matrix';
	},
});
